import { Colors, Metrics } from "../resources";
import { Modal, StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import { SModal, STitleBar } from "../components/molecules";

import { SDashboard } from "../components/templates";
import { SSearchBar } from "../components/organisms";
import { accountIds } from "../utils";
import { useUser } from "../hooks";

//import SplitPane, { Pane } from "react-split-pane";

interface IProps {
  match: any;
  headers: any;
}

const Main: React.FC<IProps> = ({ match, headers }) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [toggleFilterView, onToggleFilterView] = useState<boolean>(false);
  const [openSize, setOpensize] = useState<number>(0);
  const { user } = useUser();
  const setOpensizeVariable = (size: number) => {
    setOpensize(size);
  };

  const setToggleFilterView = (open: boolean) => {
    onToggleFilterView(open);
  };

  useEffect(() => {}, []);

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          setModalVisible(!modalVisible);
        }}
      >
        <SModal accounts={accountIds} onCloseModal={setModalVisible} />
      </Modal>

      {/* <SplitPane
        split="horizontal"
        minSize={Metrics.menuLargeHeight + Metrics.menuRegularHeight + 1}
        defaultSize={
          Metrics.menuLargeHeight + Metrics.menuRegularHeight + 1 + openSize
        }
        size={
          Metrics.menuLargeHeight + Metrics.menuRegularHeight + 1 + openSize
        }
        allowResize={toggleFilterView}
      >
        <Pane
          style={{ height: "119vh", overflowY: "scroll", overflowX: "hidden" }}
        > */}
      <STitleBar
        headers={headers}
        impersonate={user?.permissions?.includes("impersonate")}
        onPressImpersonate={setModalVisible}
      />
      <SSearchBar
        defaultFilterView={toggleFilterView}
        setOpensize={setOpensizeVariable}
        onToggleFilterView={setToggleFilterView}
      />
      {/* </Pane>
        <Pane style={{ flex: 1 }}> */}
      <SDashboard headers={headers} />
      {/* </Pane> */}
      {/* </SplitPane> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: Colors.grey100,
  },
  separator: {},
});

export default Main;
